// Bookie · Za'faron — variant that renders the standalone HTML
// template (Navro'z holiday family gathering — saffron #D88A2A on
// cream paper + gold, Yeseva One display + Cormorant Garamond
// italic body + Pinyon Script Navruz blessing, Uzbek paisley
// (botte / buta) hero corners + tiny paisley dividers above each
// section eyebrow). The HTML lives at /templates/bookie-saffron.html
// and is fully self-contained; we hand it the invitation payload
// through the iframe URL because postMessage would race the
// customizer's pre-paint text-node walk.
//
// NOTE: this template's `names` slot is a SINGLE host family name
// (e.g. "Karimov oilasi"), not a couple — the HTML customizer is
// aware and renders it as a single line. No `&`-split required.

import type { VariantProps } from "./types";
import { getLocale } from "@/lib/i18n";

const TEMPLATE_HTML = "/templates/bookie-saffron.html";

export function BookieSaffronStaticVariant({ t, ctx }: VariantProps) {
  const params = new URLSearchParams();
  if (t.names) params.set("names", t.names);
  if (t.date) {
    // Pass the original dd.mm.yyyy through — the customizer accepts
    // either dd.mm.yyyy or yyyy-mm-dd, but dd.mm.yyyy is what the
    // mock strings inside the HTML use, so the substitution loop
    // matches without a normalization round-trip.
    params.set("date", t.date);
  }
  if (t.venue) params.set("venue", t.venue);
  if (t.address) params.set("address", t.address);
  if (t.time) params.set("time", t.time);
  // The Navruz rewrite has no guestbook/server-sync features, so the
  // `slug` and `demo` params from the old wedding skeleton are no
  // longer wired to anything inside the iframe. We still forward
  // `slug` for parity with the other bookie variants (harmless query
  // string noise) but drop the demo flag.
  if (ctx.slug) params.set("slug", ctx.slug);
  // Cache buster — bump when the static HTML changes. Bumped to v2
  // because the entire occasion + section structure changed.
  params.set("v", "3");

  // Demo/catalog preview (no real invitation slug): default the template's
  // in-iframe language to the app locale, so taklifla.com previews render in
  // English (and a RU viewer sees Russian). The HTMLs read ?lang= (all) and
  // ?default_lang= (newer premium ones) — set both. Owner-published
  // invitations (ctx.slug set) keep their own default_lang / built-in default.
  if (!ctx.slug) {
    const _loc = getLocale();
    if (!params.has("lang")) params.set("lang", _loc);
    if (!params.has("default_lang")) params.set("default_lang", _loc);
  }
  const src = `${TEMPLATE_HTML}?${params.toString()}`;

  return (
    <iframe
      src={src}
      title={t.names || "Navro'z muborak"}
      style={{
        position: "fixed",
        inset: 0,
        width: "100vw",
        height: "100svh",
        border: "none",
        display: "block",
        background: "#FBF3E4",
      }}
    />
  );
}
